<template>
  <div class="svoice-dialog" :class="className" v-show="visible">
    <div class="mask" @click="hidden"></div>
    <div class="dialog-content">
      <div class="close-icon" @click="hidden" v-if="!hideClose">
        <svg-icon name="closed"></svg-icon>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'svoice-dialog',
  props: {
    visible: Boolean,
    className: String,
    hideClose: Boolean
  },
  data() {
    return {
    }
  },
  methods: {
    show () { /* 打开对话框 */
      // this.$emit('update:visible', true)
      this.$emit('show', true)
    },
    hidden () { /* 关闭对话框 */
      this.$emit('update:visible', false)
      this.$emit('close', true)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.svoice-dialog {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.5);
    cursor: pointer;
  }
  .dialog-content {
    min-width: 460px;
    min-height: 270px;
    background: #FFFFFF;
    box-shadow: 10px 10px 9px 0px rgba(85, 85, 85, 0.5);
    border-radius: 4px;
    border: 1px solid #EEEEEE;
    z-index: 1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    .close-icon {
      position: absolute;
      right: 10px;
      top: 10px;
      cursor: pointer;
      .svg-icon {
        width: 20px;
        height: 20px;
      }
    }
  }
}
</style>
